<template>
    <div>
        <transition name="fade">
            <div
                v-if="show"
                class="text-center mt-5 pt-5"
            >
                <i class="fa fa-circle-notch fa-spin fa-3x" />
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "BaseLoader",

        data: function () {
            return {
                show: false,
            }
        },

        created: function () {
            // retarde l'affichage du loader de 400ms pour ne l'afficher que si l'application met du temps à répondre
            setTimeout(() => this.show = true, 400)
        }
    }
</script>
